export { SaleIcon } from "./sale";
